<lazy-echart
    class="chart"
    *ngIf="histogramOptions"
    [options]="histogramOptions"
    [compactLoading]="compactLoading"
    [class.chart--fixed-height]="hasFixedHeight"
    (chartClick)="chartClicked($event)">
</lazy-echart>
